import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/subject-outcomes/SubjectOutcomesAction";
import * as uiHelpers from "../SubjectOutcomesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useSubjectOutcomesUIContext } from "../SubjectOutcomesUIContext";

export function SubjectOutcomesTable({ 
  deleteSubjectOutcomes
}) {
  // SubjectOutcomes UI Context
  const subjectOutcomesUIContext = useSubjectOutcomesUIContext();
  const subjectOutcomesUIProps = useMemo(() => {
    return {
      ids: subjectOutcomesUIContext.ids,
      setIds: subjectOutcomesUIContext.setIds,
      queryParams: subjectOutcomesUIContext.queryParams,
      setQueryParams: subjectOutcomesUIContext.setQueryParams,
      openEditSubjectOutcomePage: subjectOutcomesUIContext.openEditSubjectOutcomePage
    };
  }, [subjectOutcomesUIContext]);

  // Getting curret state of SubjectOutcomes list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.subjectOutcomes }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // SubjectOutcomes Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    // clear selections list
    subjectOutcomesUIProps.setIds([]);
    dispatch(actions.getSubjectOutcomes(subjectOutcomesUIProps.queryParams));
    return () => dispatch(actions.cleanSubjectOutcomesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjectOutcomesUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "outcome",
      text: "Kazanım",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "explanation",
      text: "Açıklaması",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isEditionAuthorized,
      isDeletionAuthorized,
      openEditSubjectOutcomePage: subjectOutcomesUIProps.openEditSubjectOutcomePage,
      deleteSubjectOutcomes
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    }
  }

  if (isEditionAuthorized || isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: subjectOutcomesUIProps.queryParams.pageSize,
    page: subjectOutcomesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                subjectOutcomesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: subjectOutcomesUIProps.ids,
                setIds: subjectOutcomesUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}